import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { TextArea as TextAreaAppkit } from '@pwc/appkit-react/lib/Input';

const TextArea = ({ onChange, name, type, ...props }) => {
  const onChangeHandler = useCallback(value => {
    if (onChange) {
      onChange({ target: { value, name, type } });
    }
  }, [onChange, name, type]);

  return (
    <TextAreaAppkit {...props} type={type} name={name} onChange={onChangeHandler}/>
  );
};

TextArea.defaultProps = {
  className: '',
  value: '',
  type: 'text',
};

TextArea.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export default TextArea;
